import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { createContext, useEffect, useRef, useState } from "react";
import config from "@/lib/config";

export const RecaptchaV3Context = createContext();

RecaptchaV3Context.displayName = "RecaptchaV3Context";

export function RecaptchaV3Provider({ children }) {
  const [recaptchaV3Badge, setRecaptchaV3Badge] = useState(false);

  const recaptchaV3BadgeRef = useRef(null);

  const showRecaptchaV3Badge = () => {
    setRecaptchaV3Badge(true);
  };

  const hideRecaptchaV3Badge = () => {
    setRecaptchaV3Badge(false);
  };

  const contextValue = {
    recaptchaV3Badge,
    showRecaptchaV3Badge,
    hideRecaptchaV3Badge,
  };

  useEffect(() => {
    if (recaptchaV3Badge) {
      recaptchaV3BadgeRef.current.style.visibility = "visible";
      recaptchaV3BadgeRef.current.style.position = "relative";
      recaptchaV3BadgeRef.current.style.zIndex = "9999";
    } else {
      recaptchaV3BadgeRef.current.style.visibility = "hidden";
    }
  }, [recaptchaV3Badge]);

  return (
    <RecaptchaV3Context.Provider value={contextValue}>
      <div id="recaptchaV3Badge" ref={recaptchaV3BadgeRef}></div>
      <GoogleReCaptchaProvider
        reCaptchaKey={config.reCAPTCHASiteKey.v3}
        language="ja"
        useEnterprise={true}
        container={{
          element: "recaptchaV3Badge",
          parameters: { badge: "bottomright", theme: "light" },
        }}
      >
        {children}
      </GoogleReCaptchaProvider>
    </RecaptchaV3Context.Provider>
  );
}
